const TIME_24H = /^([01]?\d|2[0-3]):([0-5]\d)$/;
const TIME_12H = /^(0?[1-9]|1[0-2]):([0-5]\d)\s*([AaPp])\.?[Mm]\.?$/;

export const toInputTime = (value?: string | null): string => {
  if (!value) return '';
  const trimmed = value.trim();
  if (TIME_24H.test(trimmed)) {
    const [h, m] = trimmed.split(':');
    return `${h.padStart(2, '0')}:${m}`;
  }
  const match = trimmed.match(TIME_12H);
  if (!match) return '';
  let hour = parseInt(match[1], 10);
  const minute = match[2];
  const period = match[3].toUpperCase();
  if (period === 'A') hour = hour === 12 ? 0 : hour;
  else hour = hour === 12 ? 12 : hour + 12;
  return `${String(hour).padStart(2, '0')}:${minute}`;
};

export const formatDisplayTime = (value?: string | null): string => {
  if (!value) return '';
  const trimmed = value.trim();
  if (TIME_12H.test(trimmed)) return trimmed.replace(/\s*([ap])\.?m\.?$/i, (_, p) => ` ${p.toUpperCase()}M`);
  const match = trimmed.match(TIME_24H);
  if (!match) return trimmed;
  const hour = parseInt(match[1], 10);
  const minute = match[2];
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:${minute} ${period}`;
};
